import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum JobSecurityRight {
    CanAccess = 1000,
    Manage = 1001,
    Dispatch = 1002,
    FinaliseJob = 1003,
    FinalliseWorkOrder = 1004,
    CompletionDate = 1005,
    FinaliseDate = 1006,
    ProcessJob = 1007,
    ProcessWorkOrder = 1008,
    ViewPricing = 1009,
    ModifyPricing = 1010,
    ManageActivity = 1011,
    ManageOtherUserActivity = 1012,
    ManagePurchaseOrder = 1013,
    ManageInvoices = 1014,
    ManageBills = 1015,
    MangeOtherUserViews = 1016,
    ModifyJobAfterFinalise = 1017,
    ReverseWorkOrderStatus = 1018,
    CanCreateViews = 1019,
    CanAccessSystemViews = 1020,
    ManageQuote = 1021,
    AccessQuote = 1022,
    ModifyLockedItems = 1023,
    ManageSalesOrder = 1024
}

export class JobSecurityModule extends BaseSecurityModule<JobSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Jobs,
            [
                { _id: JobSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: JobSecurityRight.Manage, name: 'Manage', basic: true },
                { _id: JobSecurityRight.Dispatch, name: 'Dispatch Stage', basic: false },
                { _id: JobSecurityRight.FinaliseJob, name: 'Finalise Job', basic: false },
                { _id: JobSecurityRight.FinalliseWorkOrder, name: 'Finalise Stage', basic: false },
                { _id: JobSecurityRight.CompletionDate, name: 'Modify Completion Date after the fact', basic: false },
                { _id: JobSecurityRight.FinaliseDate, name: 'Modify Finalisation Date after the fact', basic: false },
                { _id: JobSecurityRight.ProcessJob, name: 'Modify Job Status', basic: false },
                { _id: JobSecurityRight.ProcessWorkOrder, name: 'Modify Stage Status', basic: false },
                { _id: JobSecurityRight.ViewPricing, name: 'View Financial Information on Job (Sell & Buy Prices)', basic: false },
                { _id: JobSecurityRight.ModifyPricing, name: 'Modify Sell & Buy Prices on Job', basic: false },
                { _id: JobSecurityRight.ModifyJobAfterFinalise, name: 'Modify Job after Finalise', basic: false },
                { _id: JobSecurityRight.ModifyLockedItems, name: 'Modify Locked Items', basic: false },
                { _id: JobSecurityRight.ManageActivity, name: 'Manage Activity', basic: false },
                { _id: JobSecurityRight.ManageOtherUserActivity, name: 'Manage Other User Activities', basic: false },
                { _id: JobSecurityRight.ManagePurchaseOrder, name: 'Manage Purchase Orders on Job', basic: false },
                { _id: JobSecurityRight.ManageInvoices, name: 'Manage Invoices on Job', basic: false },
                { _id: JobSecurityRight.ManageBills, name: 'Manage Bills on Stage', basic: false },
                { _id: JobSecurityRight.MangeOtherUserViews, name: 'Can Manage Other User Views', basic: false },
                { _id: JobSecurityRight.ReverseWorkOrderStatus, name: 'Revert Stage Status', basic: false },
                { _id: JobSecurityRight.CanCreateViews, name: 'Can Create Views', basic: false },
                { _id: JobSecurityRight.CanAccessSystemViews, name: 'Can Access System Views', basic: false },
                { _id: JobSecurityRight.AccessQuote, name: 'Access Quotes on Jobs', basic: false },
                { _id: JobSecurityRight.ManageQuote, name: 'Manage Quotes on Jobs', basic: false },
                { _id: JobSecurityRight.ManageSalesOrder, name: 'Manage Sales Order on Jobs', basic: false },

            ] as SecurityRight<JobSecurityRight>[]
        );
    }


}
